import { render, staticRenderFns } from "./editshipprovider.vue?vue&type=template&id=de73f258"
import script from "./editshipprovider.vue?vue&type=script&lang=js"
export * from "./editshipprovider.vue?vue&type=script&lang=js"
import style0 from "./editshipprovider.vue?vue&type=style&index=0&id=de73f258&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports